/* @flow weak */
import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import Transactions from 'collections/Transactions';
import TransactionsTableRow from 'payments/components/TransactionsTableRow.jsx';
import TransactionsTableDepositRow from 'payments/components/TransactionsTableDepositRow.jsx';
import { TYPE_WITHDRAWAL, TYPE_REFUND_SENT, TYPE_PAYMENT_SENT, TYPE_PAYMENT_RECEIVED } from 'entities/Transaction.js';

import './styles/ActivityTable.scss';

class ActivityTransactionsTable extends Component {
  static propTypes = {
    transactions: PropTypes.instanceOf(Transactions).isRequired,
  };

  renderTransaction(transaction) {
    switch (transaction.getType()) {
      case TYPE_WITHDRAWAL:
        return (
          <TransactionsTableDepositRow
            key={transaction.getUuid()}
            transaction={transaction}
          />
        );
      case TYPE_PAYMENT_RECEIVED:
      case TYPE_PAYMENT_SENT:
      case TYPE_REFUND_SENT:
        return <TransactionsTableRow key={transaction.getUuid()} transaction={transaction} />;
      default:
        console.error('Unknown Transaction Status: ' + transaction.getType());
        return null;
    }
  }

  render() {
    return (
      <div className={cx('ActivityTable', this.props.className)}>
        <table className="EventDetailsTables">
          <thead>
            <tr>
              <th>Name</th>
              <th>Note</th>
              <th>Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {this.props.transactions.map(this.renderTransaction)}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ActivityTransactionsTable;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityTransactionsTable.jsx